import { render, staticRenderFns } from "./number-widget.vue?vue&type=template&id=a039267e&scoped=true&"
import script from "./number-widget.vue?vue&type=script&lang=js&"
export * from "./number-widget.vue?vue&type=script&lang=js&"
import style0 from "./number-widget.vue?vue&type=style&index=0&id=a039267e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a039267e",
  null
  
)

export default component.exports